module.exports = __webpack_public_path__ + "img/EXTERIOR-JIMNY-4.ff9be5bc.jpg";